import { instance } from "api/apiBase";
import type {
  MarkActivityReadResponse,
  MarkViewedResponse,
  NeedsLockboxCountResponse,
  UnitsFilterOptions,
  UnitsFilterOptionsParams
} from "api/units/types";
import type {
  InstructionBulkApply,
  InstructionTargetsResponse,
  InstructionType,
  Unit
} from "types/landlord/address";

interface ApplyInstructionsPayload {
  types: InstructionType[];
  target_ids?: number[];
  apply_to_all?: boolean;
  search?: string;
  excluded_ids?: number[];
}

export const unitsApi = {
  getFilterOptions: (params: UnitsFilterOptionsParams) =>
    instance
      .get<UnitsFilterOptions>("/portal/v1/units/filter_options", { params })
      .then((res) => res.data),

  getNeedsLockboxCount: () =>
    instance
      .get<NeedsLockboxCountResponse>("/portal/v1/units/needs_lockbox_count")
      .then((res) => res.data),

  markViewed: (unitId: number) =>
    instance
      .post<MarkViewedResponse>(`/portal/v1/units/${unitId}/viewed`)
      .then((res) => res.data),

  markActivityRead: (unitId: number, activityLogId: number) =>
    instance
      .post<MarkActivityReadResponse>(
        `/portal/v1/units/${unitId}/activity_read`,
        {
          activity_log_id: activityLogId
        }
      )
      .then((res) => res.data),

  updateInstructions: (
    unitId: number,
    payload: Partial<Record<`${InstructionType}_instructions`, string>>
  ) =>
    instance
      .patch<Unit>(`/portal/v1/units/${unitId}`, payload)
      .then((res) => res.data),

  getInstructionTargets: (
    unitId: number,
    params: { page: number; per_page: number; search?: string }
  ) =>
    instance
      .get<InstructionTargetsResponse>(
        `/portal/v1/units/${unitId}/instruction_targets`,
        { params }
      )
      .then((res) => res.data),

  applyInstructions: (unitId: number, payload: ApplyInstructionsPayload) =>
    instance
      .post<InstructionBulkApply>(
        `/portal/v1/units/${unitId}/apply_instructions`,
        payload
      )
      .then((res) => res.data),

  getInstructionBulkApply: (unitId: number, bulkApplyId: number) =>
    instance
      .get<InstructionBulkApply>(
        `/portal/v1/units/${unitId}/apply_instructions/${bulkApplyId}`
      )
      .then((res) => res.data),

  cancelInstructionBulkApply: (unitId: number, bulkApplyId: number) =>
    instance
      .post<InstructionBulkApply>(
        `/portal/v1/units/${unitId}/apply_instructions/${bulkApplyId}/cancel`
      )
      .then((res) => res.data)
};
